import React, {Fragment} from 'react';
import HolidaysList from "./HolidaysList";

export default function Holidays() {

    return (<Fragment>
            <HolidaysList/>
        </Fragment>
    );
}
